
import { ref, onMounted, computed } from 'vue';
import ProductItem from 'Vue/components/ProductItem/ProductItem.vue';
import { useStore } from 'vuex';
import { variantGroupings, styles, productType } from "VueInterfaces/ProductFamilyInterface";

export default {
    name: "ProductGrid",
	components: {
		ProductItem
	},
	props: {
		groupBy: {
			type: String,
			default: ''
		},
		showWholesale: {
			type: Boolean,
			default: false
		},
		styles: {
			type: Array,
			default: () => [] as styles[],
		},
		productTypes: {
			type: Array,
			default: () => [] as productType[],
		},
		products: {
			type: Array,
			default: () => [],
		},
		translations: {
			type: Object,
			default: {},
		}
	},
    setup(props) {
		const store = useStore();

		// I want to filter the array of products to only include products that have an available
		// const productsWithSelectedFinish = (products) => {
		// 	let filteredData = products.filter((item) =>
		// 		item.availableFinishes.some((finish) => finish.slug === store.state?.selectedFinish?.slug)
		// 	);
		// 	return [...filteredData];
		// }

		const filteredStyles = (products) => {
			return [...products.filter(item => item.algoliaVariantGrouping.isWholeSaleProduct)];
		};

	    const filteredTypes = (products) => {
			//console.log([...products.filter(item => item.algoliaVariantGrouping.isWholeSaleProduct)]);
		    return [...products.filter(item => item.algoliaVariantGrouping.isWholeSaleProduct)];
	    };

	    const filteredOthers = (products) => {
		    return [...products.filter(item => item.algoliaVariantGrouping.isWholeSaleProduct)];
	    };

	    const activeFinishUrl = (product) => {
			let avblFinishes = product.availableFinishes;
		    return  avblFinishes.length && avblFinishes.filter(item => item.slug === store.state?.selectedFinish?.slug).length ? (product.productDetailUrl && product.productDetailUrl.includes('?variant=') ? product.productDetailUrl + avblFinishes.filter(item => item.slug === store.state?.selectedFinish.slug)[0].variantSlug : product.productDetailUrl + store.state?.selectedFinish.slug)  : `${product.productDetailUrl}${store.state?.selectedFinish.slug}`;
	    };

        return {
			store,
	        activeFinishUrl,
	        filteredStyles,
	        filteredTypes,
	        filteredOthers
        }
    },
}
